import type { ElementFormatType } from 'lexical';

export const TEXT_ALIGNMENT_OPTIONS = ['left', 'center', 'right'] as const;

export type TextAlignment = (typeof TEXT_ALIGNMENT_OPTIONS)[number];

const TEXT_ALIGN_STYLE_PATTERN = /text-align:\s*(center|right)/;

export const isTextAlignment = (value: string): value is TextAlignment =>
  TEXT_ALIGNMENT_OPTIONS.includes(value as TextAlignment);

export const parseTextAlignFromStyle = (
  style: string | undefined,
): TextAlignment | null => {
  if (!style) {
    return null;
  }

  const match = style.match(TEXT_ALIGN_STYLE_PATTERN);

  return match && isTextAlignment(match[1]) ? match[1] : null;
};

export const isBlockAlignment = (
  format: ElementFormatType,
): format is TextAlignment => format === 'center' || format === 'right';

export const createTextAlignStyleAttribute = (format: TextAlignment) => ({
  type: 'mdxJsxAttribute' as const,
  name: 'style',
  value: `text-align: ${format}`,
});
